import {
    addDokboxFile,
    deleteDokboxFile,
    modifyDokboxFile,
} from "@/api/dokbox";

export const dokbox = {
    data() {
        return {
            formData: {
                date: "",
                name: "",
                categoryId: "",
                desc: "",
                ispublic: false,
                beraterinfo: false,
                beratertext: "",
                is360: false,
            },
            existingFormData: {},
            files: [],
            existingFiles: [],
            existingFilesToDelete: [],
            showDismissMessage: false,
            changeformDataCount: 0,
        };
    },
    watch: {
        formData: {
            deep: true,
            handler() {
                if (this.changeformDataCount > 0) {
                    this.showDismissMessage = true;
                }

                this.changeformDataCount++;
            },
        },
        files() {
            this.showDismissMessage = true;
        },
        existingFilesToDelete() {
            this.showDismissMessage = true;
        },
    },
    methods: {
        async checkSubmitStatus(submitType) {
            if (
                this.files.length === 0 &&
                this.existingFilesToDelete.length === 0 &&
                this.existingFiles.length === 0
            ) {
                this.$store.commit("dokbox/setReset", true);
                // this.$refs.modal.closeModal();
                const topModal = await this.$ionic.modalController.getTop();
                if (topModal) {
                    this.$ionic.modalController.dismiss();
                }
                let toastMessage = "";
                if (submitType === "addDokboxFile") {
                    toastMessage = "Datei(en) erfolgreich hochgeladen";
                    this.$store.commit("setAskForRating", true);
                } else if (submitType === "deleteDokboxFile") {
                    toastMessage = "Datei(en) erfolgreich gelöscht";
                } else if (submitType === "modifyDokboxFile") {
                    toastMessage = "Datei(en) erfolgreich geändert";
                }
                this.$ionic.toastController
                    .create({
                        color: "dark",
                        duration: 2000,
                        message: toastMessage,
                        showCloseButton: true,
                        closeButtonText: "Schließen",
                    })
                    .then((toast) => {
                        toast.present();
                    });
            }
        },
        deleteExistingFile(fileid) {
            this.existingFiles = this.existingFiles.filter((obj) => {
                let result = true;
                if (obj.id === fileid) {
                    this.existingFilesToDelete.push(obj);
                    result = false;
                }
                return result;
            });
        },
        submitForm() {
            for (let existingFileToDelete of this.existingFilesToDelete) {
                this.$store.commit("setLoading", true);
                deleteDokboxFile(existingFileToDelete.id).then(() => {
                    this.existingFilesToDelete.splice(
                        this.existingFilesToDelete.indexOf(
                            existingFileToDelete
                        ),
                        1
                    );
                    this.checkSubmitStatus("deleteDokboxFile");
                });
            }
            for (let file of this.files) {
                this.$store.commit("setLoading", true);
                let formData = Object.assign({}, this.formData);
                formData.file = file;
                addDokboxFile(formData).then((response) => {
                    if (response.data.Status === 200) {
                        this.files.splice(this.files.indexOf(file), 1);
                        this.checkSubmitStatus("addDokboxFile");
                    }
                });
            }
            for (let file of this.existingFiles) {
                this.$store.commit("setLoading", true);
                let formData = Object.assign({}, this.formData);
                formData.fileId = file.id;
                modifyDokboxFile(formData).then((response) => {
                    if (response.data.Status === 200) {
                        this.existingFiles.splice(
                            this.existingFiles.indexOf(file),
                            1
                        );
                        this.checkSubmitStatus("modifyDokboxFile");
                    }
                });
            }
        },
    },
};
